import { Breadcrumb, Form, message } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CustomButton, CustomInput } from "../../components";
import { useSendForgotPasswordMail } from "../../hooks/SignIn/signin.hooks";
import styles from "./style.module.scss";

const ForgotPassword = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { mutate: emailSend } = useSendForgotPasswordMail();
  const [messageApi, contextHolder] = message.useMessage();
  const [isLoading, setisLoading] = useState(false);
  const [value, setValue] = useState({
    account: "",
  });

  const onFinish = async () => {
    setisLoading(true);
    emailSend(
      { params: value },
      {
        onSuccess: () => {
          navigate("/verify", {
            state: { hasPassword: true, account: value },
          });
          setisLoading(false);
        },
        onError: (error: any) => {
          setisLoading(true);
          messageApi.open({
            type: "error",
            content: "error",
          });
          console.debug(JSON.stringify("ERR", error));
          setisLoading(false);
        },
      }
    );
  };

  const onFinishFailed = (error: any) => {
    console.log("Failed:", error);
  };

  const handleChange = (prop: any) => (event: any) => {
    setValue({ ...value, [prop]: event.target.value });
  };
  return (
    <>
      {contextHolder}
      <div className={styles.breadCrumb}>
        <Breadcrumb
          separator=">"
          items={[
            {
              title: t("normal.forgotPassword"),
            },
            {
              title: t("forgotPassword.enterEmail.page"),
            },
          ]}
        />
      </div>
      <div className={styles.forgotContainer}>
        <div className={styles.forgotTitle}>{t("normal.forgotPassword")}</div>
        <div className={styles.forgotWrapper}>
          <Form
            form={form}
            name="forgotPassword"
            autoComplete="off"
            requiredMark={false}
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <CustomInput
              formItemProps={{
                name: "email",
                label: t("forgotPassword.enterEmail"),
                rules: [
                  {
                    required: true,
                    message: t("form.required", { name: t("normal.email") }),
                  },
                  {
                    pattern:
                      /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/,
                    message: t("signup.emailFormat.error"),
                  },
                ],
              }}
              inputProps={{
                onChange: handleChange("account"),
                placeholder: t("signup.enterInput", { content: "" }),
              }}
            />
            <CustomButton
              type="primary"
              size="large"
              htmlType="submit"
              loading={isLoading}
              disabled={isLoading}
              style={{
                width: "100%",
                marginTop: "29px",
              }}
            >
              {t("normal.confirm")}
            </CustomButton>
          </Form>
        </div>
        <div className={styles.customerService}>
          <span>{t("normal.contact.cs")}</span>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
